import { useQuery } from "@tanstack/react-query"
import { useReadContracts } from "wagmi"

import {
  MEZO_CHAIN,
  ONE_MINUTE_IN_SECONDS,
  ONE_SECOND_IN_MILLISECONDS,
  queryKeysFactory,
} from "#/shared/constants"
import { MezoNativeBTC } from "#/shared/constants/artifacts"
import { goldskyApi } from "#/shared/utils"

import VeBtcAbi, {
  address as veBtcAddress,
} from "../../constants/artifacts/VeBTC"

const contracts = [
  {
    abi: VeBtcAbi,
    address: veBtcAddress,
    functionName: "totalSupply",
    chainId: MEZO_CHAIN.id,
  },
  {
    abi: MezoNativeBTC.abi,
    address: MezoNativeBTC.address,
    functionName: "balanceOf",
    args: [veBtcAddress],
    chainId: MEZO_CHAIN.id,
  },
] as const

const refetchInterval = ONE_MINUTE_IN_SECONDS * 5 * ONE_SECOND_IN_MILLISECONDS
const staleTime = refetchInterval

const useStakingStats = () => {
  const { data, isFetching } = useReadContracts<typeof contracts>({
    contracts,
    query: {
      refetchInterval,
      staleTime,
    },
  })

  const { data: stats, isFetching: isFetchingStakingStats } = useQuery({
    queryKey: queryKeysFactory.mezoKeys.stakingStats(),
    queryFn: goldskyApi.getStakingMetrics,
    refetchInterval,
    staleTime,
  })

  const [totalSupply, totalStaked] = data ?? [{ result: 0n }, { result: 0n }]

  return {
    isFetching: isFetching || isFetchingStakingStats,
    totalVotingPower: totalSupply.result ?? 0n,
    totalStaked: totalStaked.result ?? 0n,
    stakers: stats?.stakers ?? 0n,
  }
}

export default useStakingStats
